<div class="example-container mat-elevation-z2">
  <mat-table #table [dataSource]="tenants">
    <ng-container cdkColumnDef="selection">
      <mat-header-cell *cdkHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="_selection.hasValue() && isAllSelected()"
          [indeterminate]="_selection.hasValue() && !isAllSelected()"
          [aria-label]="'Select All'"
          >
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? _selection.toggle(row) : null"
          [checked]="_selection.isSelected(row)"
          [aria-label]="'Select'"
          >
        </mat-checkbox>
      </mat-cell>
    </ng-container>
    <ng-container cdkColumnDef="name">
      <mat-header-cell *cdkHeaderCellDef>Name</mat-header-cell>
      <mat-cell *cdkCellDef="let row">
        @if (row.link) {
          <a
            [routerLink]="row.link.routerLink"
            [queryParams]="row.link.queryParams"
            >{{ row.name }}</a
            >
          } @else {
            {{ row.name }}
          }
          <ng-template #name>{{ row.name }}</ng-template>
        </mat-cell>
      </ng-container>
      <ng-container cdkColumnDef="actions">
        <mat-header-cell *cdkHeaderCellDef>Actions</mat-header-cell>
        <mat-cell *cdkCellDef="let row">
          <a ca-raised-button [routerLink]="['/', row.id]">Visit Tenant</a>
        </mat-cell>
      </ng-container>
      <mat-header-row *cdkHeaderRowDef="_displayedColumns"></mat-header-row>
      <mat-row *cdkRowDef="let row; columns: _displayedColumns"></mat-row>
    </mat-table>
  </div>
